import React from 'react'
import FlowerTeal from '../../../assets/images/flower-teal.webp'
import { useSelector } from 'react-redux'
import MealCard from './MealCard'

const MealDetails = ({ grade = 'A', onClickViewMore = () => {} }) => {
  const { capturedImage, pndsScore } = useSelector((s) => s.foodScan)

  return (
    <div className="flex flex-col gap-4 px-4 pb-2">
      <div className="relative flex flex-row items-center justify-center">
        <img src={FlowerTeal} alt="flower" className="h-40 w-40 ml-20" />
        <div className="h-40 w-40 absolute rounded-4 overflow-hidden">
          <img src={capturedImage} alt="food-image" className="w-full h-full" />
        </div>
        <img src={FlowerTeal} alt="flower" className="h-40 w-40 mr-20" />
      </div>
      <MealCard
        grade={grade}
        mealDetails={pndsScore?.data?.meal_details}
        onClickViewMore={onClickViewMore}
      />
    </div>
  )
}

export default MealDetails
